<template lang="pug">
  .content
    .content-wrapper Добро пожаловать {{ currentUser.name }}!
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    currentUser () {
      return this.$store.getters.user
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainPage.vue